// What the PURCHASE toggle is allowed to write into rehab financing.
//
// It used to write `rehabFinancing` unconditionally, which turned the purchase buttons into a
// master switch: a deliberate mixed setup — borrow for the purchase and pay cash for the
// rehab, or the reverse — was flattened the moment the purchase toggle was touched. Both are
// ordinary ways to fund a flip, and the backend has always priced them independently
// (analysis_engine.py reads purchase_financing and rehab_financing in separate branches).
//
// The rule is inheritance with an owner: while nobody has chosen for rehab it follows the
// purchase mode, which is the convenience that made the old behaviour look correct. Once the
// user HAS chosen, that choice owns the field and the purchase toggle stops writing to it —
// hence an empty patch rather than a value.
//
// `touched` is a flag rather than something read back off the value, because
// `rehabFinancing === 'cash'` means two different things: the untouched default, which should
// follow, and a deliberate choice, which must not be overwritten. The value cannot separate
// those two; only the flag can.
export function rehabFinancingOnPurchaseToggle(target, touched) {
  if (touched) return {};
  return { rehabFinancing: target === 'cash' ? 'cash' : 'financed' };
}
